import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'fcp-progress-spinner',
    imports: [CommonModule, ProgressSpinnerModule],
    styleUrl: './fcp-progress-spinner.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.data-e2e-hook]': 'e2e()'
    },
    template: `
        <p-progress-spinner
            [strokeWidth]="strokeWidth()"
            [fill]="fill()"
            [animationDuration]="animationDuration()"
            [ariaLabel]="ariaLabel()"
            [style]="sizeStyles"
        >
            />
        </p-progress-spinner>
    `
})
export class FcpProgressSpinnerComponent {
    e2e = input<string | null>(null);
    strokeWidth = input<FcpProgressSpinnerStrokeWidth>(FcpProgressSpinnerStrokeWidth.Default);
    fill = input<FcpProgressSpinnerFill>(FcpProgressSpinnerFill.None);
    animationDuration = input<FcpProgressSpinnerAnimationDuration>(FcpProgressSpinnerAnimationDuration.Default);
    ariaLabel = input<string | undefined>(undefined);

    readonly sizeStyles = {
        width: '80px',
        height: '80px'
    };
}

export enum FcpProgressSpinnerStrokeWidth {
    Default = '4'
}

export enum FcpProgressSpinnerFill {
    None = 'none'
}

export enum FcpProgressSpinnerAnimationDuration {
    Default = '2s'
}

export interface FcpProgressSpinner {
    strokeWidth?: FcpProgressSpinnerStrokeWidth;
    fill?: FcpProgressSpinnerFill;
    animationDuration?: FcpProgressSpinnerAnimationDuration;
    ariaLabel?: string;
}
